// extracted by mini-css-extract-plugin
module.exports = {"viewerColumn":"Viewer_viewerColumn__2GezF"};